<template>
  <section class="p-2">
    <v-card>
      <!-- <v-card-title>
        <div style="font-size:17px;font-weight: bold;">Payout Limit Configuration </div>
      </v-card-title> -->
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Payout Limit Configuration</div>
        <div>
          <bread-crumb :bread-crumbs="['Payout Limit']" />
        </div>
      </v-card-title>
      <!-- <div class="border"></div> -->
      <v-divider class="p-0 mt-1 primary--text"></v-divider>
      <v-card-text>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="payoutLimitConf"
          sort-by="calories"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <!-- <v-toolbar-title>My CRUD</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider> -->

              <v-dialog persistent v-model="dialog" max-width="700px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn depressed 
                    color="primary"
                    dark
                    small
                    class="me-3 text-capitalize"
                    v-bind="attrs"
                    v-on="on"
                  >
                  <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                  </v-btn>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      single-line
                      hide-details
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-btn depressed  @click="downloadExcelsheet" color="primary" small
                  ><v-icon small>mdi-file-excel-outline</v-icon>Export
                </v-btn>
                </template>
                <v-card flat>
                  <v-toolbar color="secondary" dark flat dense>
                    <span class="subtitleFontsize">{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed  small icon @click="close()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <!-- <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
   -->
                  <v-form v-model="valid" ref="customerind">
                    <v-card-text class="mt-5">
                      <v-row>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize required">
                            Country
                          </label>
                          <v-autocomplete
                            v-model="payoutLimitdata.country_code"
                            :items="countryOptions"
                            class="rounded"
                            item-text="txt"
                            item-value="val"
                            dense
                            outlined
                            :error-messages="countryy"
                            @input="$v.payoutLimitdata.country_code.$touch()"
                            @blur="$v.payoutLimitdata.country_code.$touch()"
                            placeholder=" Country"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize required"
                            >Currency</label
                          >
                          <v-autocomplete
                            v-model="payoutLimitdata.currency_code"
                            :items="currencyOptions"
                            :error-messages="currency"
                            @input="$v.payoutLimitdata.currency_code.$touch()"
                            @blur="$v.payoutLimitdata.currency_code.$touch()"
                            class="rounded"
                            dense
                            outlined
                            placeholder="Currency"
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class=""
                          ><label class="my-0 labelFontsize required">
                            Payment Mode
                          </label>
                          <v-autocomplete
                            v-model="payoutLimitdata.payment_mode"
                            :items="modeOptions"
                            :error-messages="payment"
                            @input="$v.payoutLimitdata.payment_mode.$touch()"
                            @blur="$v.payoutLimitdata.payment_mode.$touch()"
                            class="rounded"
                            item-text="txt"
                            item-value="val"
                            dense
                            outlined
                            placeholder="Payment Mode"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize required">
                            Paying Partner
                          </label>
                          <v-autocomplete
                            v-model="payoutLimitdata.paying_partner_id"
                            :items="payingPartner"
                            class="rounded"
                            dense
                            item-text="txt"
                            item-value="val"
                            outlined
                            placeholder="Paying Partner"
                            :error-messages="paying"
                            @input="
                              $v.payoutLimitdata.paying_partner_id.$touch()
                            "
                            @blur="
                              $v.payoutLimitdata.paying_partner_id.$touch()
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label class="my-0 labelFontsize required">
                            No.of Txn Per Day
                          </label>
                          <v-text-field
                            v-model="payoutLimitdata.no_of_txn_per_day"
                            class="rounded"
                            dense
                            outlined
                            placeholder="No.of Txn Per Day "
                            :error-messages="TxnperDay"
                            @input="
                              $v.payoutLimitdata.no_of_txn_per_day.$touch()
                            "
                            @blur="
                              $v.payoutLimitdata.no_of_txn_per_day.$touch()
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label class="my-0 labelFontsize required">
                            No.of Txn Last 30 Days
                          </label>
                          <v-text-field
                            v-model="payoutLimitdata.no_of_txn_per_month"
                            class="rounded"
                            dense
                            outlined
                            placeholder=" No.of Txn Last 30 Days"
                            :error-messages="Txnpermonth"
                            @input="
                              $v.payoutLimitdata.no_of_txn_per_month.$touch()
                            "
                            @blur="
                              $v.payoutLimitdata.no_of_txn_per_month.$touch()
                            "
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="6">
                    <label class="my-0 labelFontsize "> No.of Txn per Year </label>
                    <v-text-field
                     
                      class="rounded"
                      dense
                      outlined
                      placeholder="No.of Txn per Year"
                    ></v-text-field>
                  </v-col> -->
                        <v-col cols="12" sm="6" md="6">
                          <label class="my-0 labelFontsize required">
                            Receiver Type
                          </label>
                          <v-autocomplete
                            v-model="payoutLimitdata.receiver_type"
                            :items="[
                              { text: 'Individual', value: 'IND' },
                              { text: 'Bussiness', value: 'BUS' },
                            ]"
                            class="rounded"
                            dense
                            outlined
                            placeholder="Receiver Type"
                            :error-messages="remittype"
                            @input="$v.payoutLimitdata.receiver_type.$touch()"
                            @blur="$v.payoutLimitdata.receiver_type.$touch()"
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize required">
                            Amount Per Txn
                          </label>
                          <v-text-field
                            v-model="payoutLimitdata.pay_limit_per_txn"
                            class="rounded"
                            :error-messages="limit"
                            @input="
                              $v.payoutLimitdata.pay_limit_per_txn.$touch()
                            "
                            @blur="
                              $v.payoutLimitdata.pay_limit_per_txn.$touch()
                            "
                            dense
                            outlined
                            placeholder="Amount Per Txn "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize required">
                            Amount Per Day
                          </label>
                          <v-text-field
                            v-model="payoutLimitdata.pay_limit_per_day"
                            class="rounded"
                            dense
                            :error-messages="limitperday"
                            @input="
                              $v.payoutLimitdata.pay_limit_per_day.$touch()
                            "
                            @blur="
                              $v.payoutLimitdata.pay_limit_per_day.$touch()
                            "
                            outlined
                            placeholder="Amount Per Day "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize required">
                            Amount Last 30 days
                          </label>
                          <v-text-field
                            v-model="payoutLimitdata.pay_limit_per_month"
                            class="rounded"
                            :error-messages="limitpermonth"
                            @input="
                              $v.payoutLimitdata.pay_limit_per_month.$touch()
                            "
                            @blur="
                              $v.payoutLimitdata.pay_limit_per_month.$touch()
                            "
                            dense
                            outlined
                            placeholder="Amount Last 30 days "
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn depressed 
                      color="primary"
                      small
                      class="text-capitalize"
                      @click="onclickNext()"
                      v-if="!payoutLimitdata.id"
                    >
                    <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                    </v-btn>
                    <v-btn depressed 
                      color="primary"
                      small
                      class="text-capitalize ms-2"
                      @click="close()"
                      outlined
                      v-if="!payoutLimitdata.id"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>
                    <v-btn depressed 
                      color="primary"
                      small
                      class="text-capitalize"
                      @click="onupdate()"
                      v-if="payoutLimitdata.id"
                    >
                    <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon> Update
                    </v-btn>
                    <v-btn depressed 
                      color="primary"
                      class="text-capitalize ms-2"
                      @click="close()"
                      small
                      outlined
                      v-if="payoutLimitdata.id"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>

                    <!-- <v-btn depressed  color="primary" class="text-capitalize ms-2" @click="close" outlined v-if="Collectiondata.id">
                    Cancel
                  </v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small color="primary " class="mr-2" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="deleteItem(item)"
              color="primary"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
        </v-data-table>
        <v-dialog persistent v-model="openDialog" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete this Payout Limit?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed  small color="primary" outlined @click="onDeletecoll">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn depressed  small color="primary" outlined @click="closeDelete()"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { required, numeric } from "vuelidate/lib/validators";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService.js";
import commonService from "@/services/CommonService/commonService.js";
// import { Partnervalidations } from "../../utils/validation";
export default {
  name: "Payout Limit",
  mixins: [alerts],
  data: () => ({
    // ...Partnervalidations,
    dialog: false,
    loader: false,
    dialogDelete: false,
    openDialog: false,
    payoutLimitdata: {
      country_code: "",
      currency_code: "",
      payment_mode: "",
      pay_limit_per_txn: null,
      pay_limit_per_day: null,
      pay_limit_per_month: null,
      no_of_txn_per_day: null,
      no_of_txn_per_month: null,
      receiver_type: "",
      paying_partner_id: "",
    },
    defaultItem: {
      country_code: "",
      currency_code: "",
      payment_mode: "",
      pay_limit_per_txn: null,
      pay_limit_per_day: null,
      pay_limit_per_month: null,
      no_of_txn_per_day: null,
      no_of_txn_per_month: null,
      receiver_type: "",
      paying_partner_id: "",
    },

    headers: [
      {
        text: "Country",
        align: "start",
        sortable: false,
        value: "country_code.name",
      },
      { text: "Currency", value: "currency_code", align: "start" },
      {
        text: "Partner",
        value: "paying_partner_id.partner_name",
        align: "start",
      },
      {
        text: "Paying Mode",
        value: "payment_mode.payment_mode",
        align: "start",
      },
      {
        text: "No.of Txn Per Day",
        value: "no_of_txn_per_day",
        align: "start",
      },
      {
        text: "No.of Txn Last 30 Days ",
        value: "no_of_txn_per_month",
        align: "start",
      },
      { text: "Receiver Type", value: "receiver_type", align: "start" },
      { text: "Amount Per Txn ", value: "pay_limit_per_txn", align: "start" },
      { text: "Amount Per Day ", value: "pay_limit_per_day", align: "start" },
      {
        text: "Amount Last 30 days",
        value: "pay_limit_per_month",
        align: "start",
      },
      { text: "Actions", value: "actions", sortable: false, align: "start" },
    ],
    search: "",
    payoutLimitConf: [],
    payingPartner: [],
    Options: "",
    countryOptions: [],
    currencyOptions: [],
    modeOptions: [],
    payment_Location: [],
    // paymentmode: {},
    // country: {},
    // currencylist: {},
    payoutLocation: "",
    editedIndex: -1,
    selectedItem: null,
    valid: true,
  }),

  computed: {
    countryy() {
      const errors = [];
      if (!this.$v.payoutLimitdata.country_code.$dirty) return errors;
      !this.$v.payoutLimitdata.country_code.required &&
        errors.push(this.$t("Country is requried"));
      return errors;
    },

    currency() {
      const errors = [];
      if (!this.$v.payoutLimitdata.currency_code.$dirty) return errors;
      !this.$v.payoutLimitdata.currency_code.required &&
        errors.push(this.$t("Currency Code is requried"));
      return errors;
    },
    payment() {
      const errors = [];
      if (!this.$v.payoutLimitdata.payment_mode.$dirty) return errors;
      !this.$v.payoutLimitdata.payment_mode.required &&
        errors.push(this.$t("Payment Mode is requried"));
      return errors;
    },
    paying() {
      const errors = [];
      if (!this.$v.payoutLimitdata.paying_partner_id.$dirty) return errors;
      !this.$v.payoutLimitdata.paying_partner_id.required &&
        errors.push(this.$t("Payment Partner is requried"));
      return errors;
    },

    TxnperDay() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.payoutLimitdata.no_of_txn_per_day.$dirty) return errors;
      !this.$v.payoutLimitdata.no_of_txn_per_day.required &&
        errors.push(this.$t("Enter No Of Txn"));
      !this.$v.payoutLimitdata.no_of_txn_per_day.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    Txnpermonth() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.payoutLimitdata.no_of_txn_per_month.$dirty) return errors;
      !this.$v.payoutLimitdata.no_of_txn_per_month.required &&
        errors.push(this.$t("Enter No Of Txns Last 30 days"));
      !this.$v.payoutLimitdata.no_of_txn_per_month.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    limit() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.payoutLimitdata.pay_limit_per_txn.$dirty) return errors;
      !this.$v.payoutLimitdata.pay_limit_per_txn.required &&
        errors.push(this.$t("Enter Amount Per Txn"));
      !this.$v.payoutLimitdata.pay_limit_per_txn.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    limitperday() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.payoutLimitdata.pay_limit_per_day.$dirty) return errors;
      !this.$v.payoutLimitdata.pay_limit_per_day.required &&
        errors.push(this.$t("Enter Amount Per Day"));
      !this.$v.payoutLimitdata.pay_limit_per_day.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },

    limitpermonth() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.payoutLimitdata.pay_limit_per_month.$dirty) return errors;
      !this.$v.payoutLimitdata.pay_limit_per_month.required &&
        errors.push(this.$t("Enter Amount Last 30 Days"));
      !this.$v.payoutLimitdata.pay_limit_per_month.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    remittype() {
      const errors = [];
      if (!this.$v.payoutLimitdata.receiver_type.$dirty) return errors;
      !this.$v.payoutLimitdata.receiver_type.required &&
        errors.push(this.$t("Receiver Type is requried"));
      return errors;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },

  validations() {
    return {
      payoutLimitdata: {
        country_code: {
          required,
        },
        currency_code: {
          required,
        },
        payment_mode: {
          required,
        },
        paying_partner_id: {
          required,
        },
        no_of_txn_per_month: {
          required,
          numeric,
        },
        no_of_txn_per_day: {
          required,
          numeric,
        },
        receiver_type: {
          required,
        },
        pay_limit_per_txn: {
          required,
          numeric,
        },
        pay_limit_per_day: {
          required,
          numeric,
        },
        pay_limit_per_month: {
          required,
          numeric,
        },
      },
    };
  },
  components: {
    BreadCrumb,
    Loading,
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    "payoutLimitdata.country_code"(val) {
      console.log("country code", val);
      if (val) {
        this.getcurrencyList(val);
        this.getpaypartner(val);
      }
    },
    "payoutLimitdata.paying_partner_id"(val) {
      console.log(val);
    },
    //     country(val){
    //         if(val) {
    //             this.payoutLimitdata.country_code=val.iso_alpha3
    //         }
    // console.log("val",val)
    //     },
    //     currencylist(val){
    //         if(val) {
    //             this.payoutLimitdata.currency_code=val
    //         }
    // console.log("val",val)
    //     },
    paymentmode(val) {
      console.log(val);
      this.payoutLimitdata.payment_mode = val;
      console.log("val", val);
    },
    // payoutLocation(val){

    //     this.payoutLimitdata.paying_partner_id=val.locationId
    //     console.log("val",val)
    // }
  },

  mounted() {
    this.getcountryList();
    // this.getcurrencyList();
    this.getpaymentmode();
    this.getallTabledata();
    // this.getpaypartner();
    // this.getpayLocation();
  },

  methods: {
    async downloadExcelsheet() {
      if (this.payoutLimitConf) {
        this.exportToExcel(this.headers, this.payoutLimitConf, "payout Limit");
      }
    },
    async getallTabledata() {
      this.loader = true;
      try {
          const responseData = await setupService.getPayoutLimit()
          this.loader = false;
          if (responseData.data.status_code === 200) {
            this.payoutLimitConf = responseData.data.data;
          } 
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.getallTabledata();
          // } 
          console.log("getallparameters", responseData);
        } catch (err) {
          this.loader = false;
          console.error(err);
        }
    },
    editItem(item) {
      this.getcountryList(item);
      this.getpaymentmode();
      console.log("item", item);
      this.selectedItem = item;
      this.editedIndex = this.payoutLimitConf.indexOf(item);
      this.dialog = true;
      this.payoutLimitdata.payment_mode = item.payment_mode.payment_mode_code;
      this.payoutLimitdata.no_of_txn_per_day = item.no_of_txn_per_day;
      this.payoutLimitdata.no_of_txn_per_month = item.no_of_txn_per_month;
      this.payoutLimitdata.pay_limit_per_day = item.pay_limit_per_day;
      this.payoutLimitdata.pay_limit_per_month = item.pay_limit_per_month;
      this.payoutLimitdata.pay_limit_per_txn = item.pay_limit_per_txn;
      this.payoutLimitdata.receiver_type = item.receiver_type;
      this.payoutLimitdata.id = item.id;
    },

    close() {
      this.dialog = false;
      this.$v.$reset();
      this.$nextTick(() => {
        this.payoutLimitdata = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    onclickNext() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.saveData();
    },

    ClickBack() {
      this.$emit("onClickBack");
    },
    async saveData() {
      // const validate = this.$refs.customerind.validate();
      // console.log("validate " + validate);
      this.loader = true;
      if (this.editedIndex > -1) {
        Object.assign(
          this.payoutLimitConf[this.editedIndex],
          this.payoutLimitdata
        );
      } else {
        // this.payoutLimitdata.paying_partner_id = this.locationdetails,
        console.log(" this.locationdetails", this.locationdetails);
        try {
          const responseData = await setupService.savePayoutLimit(this.payoutLimitdata.receiver_type, this.payoutLimitdata)
          this.loader = false;
          console.log(`responseData: ${JSON.stringify(responseData)}`);
          if (responseData && responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getallTabledata();
          } 
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.saveData();
          // }
          console.log("getallparameters", responseData);
        } catch (err) {
          console.log(err.response);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }

      this.close();
    },

    onupdate() {
      // alert('i am  here')
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.update();
    },

    async update() {
      this.loader = true;
      try {
        const responseData = await setupService.updatePayoutLimit(this.payoutLimitdata.id, this.payoutLimitdata)
        console.log(`responseData: ${JSON.stringify(responseData)}`);
        if (responseData && responseData.data.status_code === 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
          this.getallTabledata();
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.update();
        // }
        console.log("getallparameters", responseData);
      } catch (err) {
        console.log(err.response);
        this.showAlertError("Something went wrong please try again later.");
      }
      this.close();
    },
    async getcountryList(selectedItem) {
      try {
        const responseData = await commonService.getdropdowns()
        console.log(`responseData: ${JSON.stringify(responseData)}`);
        if (responseData.status === 200) {
          this.countryOptions = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
              currency_code: i.currency_code,
            };
          });
          console.log("countryOptions", this.countryOptions);
          this.countryOptions.find((ele) => {
            if (ele.val == this.payoutLimitdata.country_code) {
              this.payoutLimitdata.country_code = ele.txt;
            }
          });
          // condition for mapping country while editing
          if (
            selectedItem.country_code &&
            selectedItem.country_code.iso_alpha3
          ) {
            this.payoutLimitdata.country_code =
              selectedItem.country_code.iso_alpha3;
          }
        } 
        // else if (responseData.status === 401) {
        //   this.returnNewToken();
        //   this.getcountryList(selectedItem);
        // }
        console.log("countrys", responseData);
      } catch (err) {
        console.error(err);
      }
    },
    async getcurrencyList(country_code) {
      try {
        const responseData = await commonService.getdropdowns()
        console.log(`responseData: ${JSON.stringify(responseData)}`);
        if (responseData.status === 200) {
          this.currencyOptions = responseData.data.data.map((i) => {
            return {
              text: i.currency_code,
              values: i.country_name,
              id: i.id,
              iso_alpha3: i.iso_alpha3,
            };
          });
          console.log("countryOptions", this.countryOptions);
          this.countryOptions.find((ele) => {
            if (ele.val == this.payoutLimitdata.country_code) {
              this.payoutLimitdata.country_code = ele.txt;
            }
          });
          this.currencyOptions.find((ele) => {
            if (ele.iso_alpha3 == country_code) {
              this.payoutLimitdata.currency_code = ele.text;
            }
          });
        }
        //  else if (responseData.status === 401) {
        //   this.returnNewToken();
        //   this.getcurrencyList(country_code);
        // }
        console.log("currency_code", responseData);
      } catch (err) {
        console.error(err);
      }
    },
    async getpaymentmode() {
      try {
        const code = 'PTY'
        const responseData = await commonService.getparameterdropdowns(code)
        if (responseData.status === 200) {
          this.modeOptions = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        } 
        // else if (responseData.status === 401) {
        //   this.returnNewToken();
        //   this.getpaymentmode();
        // }
        console.log("paymentmode", responseData);
      } catch (err) {
        console.error(err);
      }
    },
    async getpaypartner(countrycode) {
      try {
        const responseData = await commonService.getPayPartner(countrycode)
        if (responseData.status === 200) {
          this.payingPartner = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        if (
          this.selectedItem.paying_partner_id &&
          this.selectedItem.paying_partner_id.partner_id
        ) {
          this.payoutLimitdata.paying_partner_id =
            this.selectedItem.paying_partner_id.partner_id;
        }
        // else if (responseData.status === 401) {
        //   this.returnNewToken();
        //   this.getpaypartner(countrycode);
        // }
        console.log("paymentmode", responseData);
      } catch (err) {
        console.error(err);
      }
    },
    deleteItem(item) {
      this.openDialog = true;
      (this.remarks = item.remarks),
        (this.id = item.id),
        console.log("item", item);
    },
    closeDelete() {
      this.openDialog = false;
    },
    async onDeletecoll() {
      try {
        this.loader = true;
        const responseData = await setupService.deletePayoutLimit(this.id)
        console.log("item", responseData);
        if (responseData && responseData.status === 200) {
          this.loader = false;
          this.closeDelete();
          this.getallTabledata();
          this.showAlertSuccess(responseData.data.message);
        } 
        // else if (responseData.data.status === 401) {
        //   this.returnNewToken();
        //   this.onDeletecoll();
        // }
      } catch (error) {
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

.required:after {
  content: " *";
  color: red;
}
</style>
